<modal>
  <span header>{{partner.ID < 1 ? ('Tạo đối tác mới' | lang) : ('Chỉnh sửa đối tác' | lang) + ' ' + partner.Name }}</span>
  <p>{{'Tên đối tác' | lang}}</p>
  <input type="text" [(ngModel)]="partner.Name" />
  <p>{{'Địa chỉ' | lang}}</p>
  <input type="text" [(ngModel)]="partner.Address" />
  <p>{{'Số điện thoại' | lang}}</p>
  <input type="text" [(ngModel)]="partner.Phone" />
  <p>{{'Email' | lang}}</p>
  <input type="text" [(ngModel)]="partner.Email" />
  <p>{{'Người phụ trách' | lang}}</p>
  <select [(ngModel)]="partner.DealerID">
    <option value="0">{{'chưa có' | lang}}</option>
    <option *ngFor="let i of users.matches" value="{{i.ID}}">{{i.Username}}</option>
  </select>
  <div class="flex">
    <button class="text-white bg-success" (click)="save()"><i class="fa fa-save"></i><span>{{'Lưu' | lang}}</span></button>
    <button class="text-white bg-warning" (click)="close()"><i class="fa fa-arrow-left"></i><span>{{'Quay lại' | lang}}</span></button>
  </div>
</modal>
